import Vue from 'vue';

export const eventBus = new Vue();

export const eventBusEvents = {
    activateSearchResultLoading: 'activateSearchResultLoading',
    deactivateSearchResultLoading: 'deactivateSearchResultLoading',
    activateGlobalLoading: 'activateGlobalLoading',
    deactivateGlobalLoading: 'deactivateGlobalLoading',
    injectFilterData: 'injectFilterData',
    enableNavigation: 'enableNavigation',
    disableNavigation: 'disableNavigation',
};
